var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReloadDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "reload"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.7166 0.666016L11.1152 1.4112C11.3847 1.91499 11.5195 2.16689 11.4304 2.27477C11.3413 2.38265 11.0478 2.29552 10.4609 2.12127C9.87407 1.94705 9.25107 1.85332 8.60547 1.85332C5.10767 1.85332 2.27214 4.60499 2.27214 7.99938C2.27214 9.11878 2.58055 10.1684 3.11943 11.0724M6.49436 15.3327L6.09571 14.5875C5.82619 14.0837 5.69143 13.8318 5.78054 13.7239C5.86965 13.616 6.16313 13.7032 6.75007 13.8774C7.33687 14.0516 7.95987 14.1454 8.60547 14.1454C12.1033 14.1454 14.9388 11.3937 14.9388 7.99938C14.9388 6.87991 14.6304 5.83033 14.0915 4.92633",
    stroke: "#001E60",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReloadDark);
export default __webpack_public_path__ + "static/media/reload-dark.d6e4f68620a97b8612a470e73cc7ed63.svg";
export { ForwardRef as ReactComponent };